import React from "react";
import {
  Box,
  CircularProgress,
  Typography,
} from "@mui/material";
import { AppButton, AppTextField } from "./ui";

const AuthForm = ({ title, fields, onSubmit, isLoading, footerAction }) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    padding={2}
  >
    <Box
      width="100%"
      maxWidth={400}
      p={4}
      bgcolor="var(--color-bg-card, #ffffff)"
      sx={{
        border: "1px solid var(--color-border-subtle, rgba(0, 0, 0, 0.12))",
        borderRadius: "12px",
        boxShadow: "var(--shadow-card-rest, 0 1px 2px rgba(0, 0, 0, 0.08))",
      }}
    >
      <Typography variant="h2" component="h1" align="center" gutterBottom>
        {title}
      </Typography>
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        noValidate
      >
        {fields.map(({ label, type, value, onChange }, index) => (
          <AppTextField
            key={index}
            label={label}
            type={type}
            fullWidth
            margin="normal"
            value={value}
            onChange={onChange}
            required
            InputLabelProps={{
              shrink: true, // Force the label to shrink
            }}
          />
        ))}
        <Box display="flex" justifyContent="center" marginTop={2}>
          <AppButton
            type="submit"
            fullWidth
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : "Submit"}
          </AppButton>
        </Box>
      </Box>
      {footerAction && (
        <Box textAlign="center" marginTop={2}>
          {footerAction}
        </Box>
      )}
    </Box>
  </Box>
);

export default AuthForm;
